// 批量操作
export const selectionMixins = {
  props: {
    // 是否跨页选择
    reserveSelection: {
      type: Boolean,
      default: false
    },
    // 批量删除
    batchDelete: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 显示批量删除
    showBatchOperation() {
      return this.multipleSelection.length && this.batchDelete;
    }
  },
  data() {
    return {
      multipleSelection: []
    };
  },
  methods: {
    // 切换当前页选择
    handleCheckCurrentPage() {
      this.$refs.generalTable.toggleAllSelection();
    },
    // 清空选择
    handleEmptySelection() {
      this.multipleSelection = [];
      this.$refs.generalTable.clearSelection();
    },
    // selection变化同步数据
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    // 批量删除（兼容老数据）
    handleBatchDeleteData() {
      this.$emit("batchDeleteData", this.multipleSelection);
    }
  }
};
